import { Injectable } from '@angular/core';
import { AIASSIST_FUNCTIONS_NAMESPACE, FUNCTIONS_NAMESPACE } from '../interfaces/imetadata';
import { FieldContext } from '../utils/fieldcontext';
import { ApplicationStoreService } from './application-store.service';
import { FunctionsModelService } from './functions-model.service';

@Injectable({ providedIn: 'root' })
export class AiAssistFunctionService {
  private static readonly AI_ASSIST_PROMPT_FUNCTION_NAME = 'aiAssistPrompt';

  constructor(private applicationStoreService: ApplicationStoreService, private functionsModelService: FunctionsModelService) {}

  async insert(fieldContext: FieldContext): Promise<FieldContext> {
    if (!fieldContext.isAiAssistField) {
      return fieldContext;
    }

    const aiAssistFieldConfig = fieldContext.aiAssistFieldConfig!;

    // leaf is used by the model part as the element name
    // must be unique as it is used as the "out" path for the function config
    const refId = await this.applicationStoreService.incrementRefId();
    fieldContext.field.path = `${FUNCTIONS_NAMESPACE}.${fieldContext.namespace}.aiassist_${refId}`;

    const functionConfig = {
      name: AiAssistFunctionService.AI_ASSIST_PROMPT_FUNCTION_NAME,
      args: {
        corpId: aiAssistFieldConfig.corpId,
        promptProfileId: aiAssistFieldConfig.promptId,
      },
      out: fieldContext.field.path,
      namespace: fieldContext.namespace,
    };

    aiAssistFieldConfig.functionId = await this.functionsModelService.insert(
      AIASSIST_FUNCTIONS_NAMESPACE,
      fieldContext.namespace,
      functionConfig
    );

    return fieldContext;
  }

  async update(fieldContext: FieldContext): Promise<FieldContext> {
    if (!fieldContext.isAiAssistField) {
      return fieldContext;
    }

    const aiAssistFieldConfig = fieldContext.aiAssistFieldConfig!;

    await this.functionsModelService.delete(fieldContext.namespace, aiAssistFieldConfig.functionId);

    const functionConfig = {
      name: AiAssistFunctionService.AI_ASSIST_PROMPT_FUNCTION_NAME,
      args: {
        corpId: aiAssistFieldConfig.corpId,
        promptProfileId: aiAssistFieldConfig.promptId,
      },
      out: fieldContext.field.path,
      namespace: fieldContext.namespace,
    };

    aiAssistFieldConfig.functionId = await this.functionsModelService.insert(
      fieldContext.namespace,
      fieldContext.namespace,
      functionConfig
    );

    return fieldContext;
  }
}
